/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { HubbleShipmentFiltersQuery, LookupResult } from "../models/index";
import {
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryToJSON,
  LookupResultFromJSON,
  LookupResultToJSON,
} from "../models/index";

export interface LookupRequest {
  query: string;
  hubbleShipmentFiltersQuery: HubbleShipmentFiltersQuery;
}

/**
 *
 */
export class LookupApi extends runtime.BaseAPI {
  /**
   */
  async lookupRaw(
    requestParameters: LookupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LookupResult>> {
    if (requestParameters["query"] == null) {
      throw new runtime.RequiredError(
        "query",
        'Required parameter "query" was null or undefined when calling lookup().',
      );
    }

    if (requestParameters["hubbleShipmentFiltersQuery"] == null) {
      throw new runtime.RequiredError(
        "hubbleShipmentFiltersQuery",
        'Required parameter "hubbleShipmentFiltersQuery" was null or undefined when calling lookup().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["query"] != null) {
      queryParameters["query"] = requestParameters["query"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/lookup`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: HubbleShipmentFiltersQueryToJSON(
          requestParameters["hubbleShipmentFiltersQuery"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LookupResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async lookup(
    requestParameters: LookupRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LookupResult> {
    const response = await this.lookupRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
